import React from "react";

const GLYPHS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/\\<>[]{}";
// 22 символа × 85 мс ≈ 1.9 с — совпадает с растянутой раскадровкой Welcome.
const STEP_MS = 85;

const prefersReducedMotion = () =>
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * D. Decode-проявление. Правило: никогда на пользовательских данных — имена
 * проектов, URL и тексты ошибок читают, а не смотрят.
 *
 * Анимируемый span скрыт от скринридера, рядом лежит статичный текст: иначе
 * ассистивные технологии озвучили бы мусор из глифов.
 *
 * DOM обновляется напрямую через ref, без setState: 14 ре-рендеров React на
 * каждый заголовок — плата ни за что.
 */
class KodeDecodeText extends React.Component {
  constructor(props) {
    super(props);
    this.spanRef = React.createRef();
    this.timer = null;
  }

  componentDidMount() {
    const text = this.props.text;
    if (prefersReducedMotion() || !this.spanRef.current) {
      return;
    }
    let revealed = 0;
    this.spanRef.current.textContent = this.scramble(text, 0);
    this.timer = setInterval(() => {
      revealed += 1;
      if (!this.spanRef.current) {
        return;
      }
      if (revealed >= text.length) {
        this.spanRef.current.textContent = text;
        clearInterval(this.timer);
        this.timer = null;
        return;
      }
      this.spanRef.current.textContent = this.scramble(text, revealed);
    }, STEP_MS);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  scramble(text, revealed) {
    let output = text.slice(0, revealed);
    for (let index = revealed; index < text.length; index += 1) {
      output += text[index] === " " ? " " : GLYPHS[(index * 7 + revealed * 13) % GLYPHS.length];
    }
    return output;
  }

  render() {
    return (
      <React.Fragment>
        <span
          ref={this.spanRef}
          aria-hidden="true"
          className={this.props.className}
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          {this.props.text}
        </span>
        <span
          style={{
            position: "absolute",
            width: 1,
            height: 1,
            overflow: "hidden",
            clip: "rect(0 0 0 0)",
            whiteSpace: "nowrap",
          }}
        >
          {this.props.text}
        </span>
      </React.Fragment>
    );
  }
}

export default KodeDecodeText;
